<div class="content-wrapper notifications-page">
  <div class="page-content recruiterpanel">
    
    <div class="iboxcontent mt-4 pb-5">
      <h3> Notification Management </h3>
   </div> 
      <div class="row">
          <!-- Active users -->
          <div class="col-lg-12">
            <div class="container p-0 infinite-scroll" infinite-scroll [infiniteScrollDistance]="modalScrollDistance"
            [infiniteScrollThrottle]="modalScrollThrottle" [scrollWindow]="false" (scrolled)="onModalScrollDown()">
                  <!-- 1 -->
                  <div class="card-holder ibox" *ngFor="let data of allData">
                    <div class="top-box row">
                        <div class="author-profile col-md-6">
                          <div class="imgbox">
                            <img src="../../../assets/images/profile-img.jpg">
                            <span *ngIf="data?.isRead == 0" class="dotGreen"></span>
                          </div>
                            <div class="admin-name">                
                              <h6> {{data.title}} </h6>
                              <p> {{data.message}} </p>
                            </div>
                        </div> 
                        <div class="author-details  col-md-6">
                            <span class="notifications-time"> {{dateInMilisecond(data?.createdAt) | dateAgoConvert}} </span> 
                            <a href="javascript:void(0);" (click)="redirectTo(data)" class="apply_btn"> View</a>   
                        </div>
                    </div> 
                  </div> 
                  <div class="noDataFound" *ngIf="allData?.length == 0 && noData">
                    <h2>No Records Found</h2>
                  </div>
                </div>
          </div> 
          
      </div>
  </div>
</div> 